import { Component, OnInit, Output, EventEmitter, HostListener, OnChanges, Input, SimpleChange, ViewChild } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { ParamsMedia, FilterMedia, MediaQueovalModel, MediaExtranetModel, MaxSizesMedias, Alert, AlertCode, MediaTypeCode, eConfigKey } from '../../models';
import { UtilitiesService, MediaService, CoreService } from '../../services';
import { ModalService } from '../../modal';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { TagComponent } from '../../tag';

class CheckPreviews {
  public isOk: boolean;
  public ArrayPreviews: Array<PreviewsIndexSize>;
}

class PreviewsIndexSize {
  index: number;
  size: number;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-new-media',
  templateUrl: './new_media.component.html',
  styleUrls: ['./new_media.component.css', '../media.component.css'],
})

export class NewMediaComponent implements OnInit, OnChanges {

  public media: ParamsMedia;
  public mediaPreviewsToDelete: Array<string>;
  public defaultName: string;
  public displayMedia: string | ArrayBuffer | null;
  public displayPreview: string | ArrayBuffer | null;
  public previewName: string;
  public ArrayTypes: Array<{ key: string; value: string }>;
  public maxSizesMedias: MaxSizesMedias = new MaxSizesMedias();
  /**
* format de l'image
* @example .png
*/
  public fileObj: any;
  public previewObjList: Array<any>;
  public accept: string;

  //  /**
  //* Player Plyr
  //*/
  //  public playerPlyr: any;

  @Input('updateMedia') updateMedia: ParamsMedia;
  @Input('restrictedTo') restrictedTo: FilterMedia;

  @Output() newMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @Output() resetMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @HostListener('drop', ['$event']) public onDrop(evt: any): void {
    evt.preventDefault();
    evt.stopPropagation();
    const files: File[] = evt.dataTransfer.files;
  }

  @ViewChild(TagComponent, { static: false }) tag: TagComponent;


  constructor(
    private dialogService: DialogService,
    private toast: ToastService,
    private mediaService: MediaService,
    private utilities: UtilitiesService,
    public modalService: ModalService,
    public coreService: CoreService,
  ) {

  }
  // #region CYCLE DE VIE
  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    this.UnselectMedia('Main');
    for (const propName in changes) {
      if (propName === 'updateMedia') {
        const _media: ParamsMedia = changes[propName].currentValue ? JSON.parse(JSON.stringify(changes[propName].currentValue)) : new ParamsMedia;
        this.media = _media;
        //this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
      }
    }
  }

  ngOnInit(): void {
    this.maxSizesMedias.audio = Number(this.coreService.getConfigKey(eConfigKey.AUDIOSIZE));
    this.maxSizesMedias.document = Number(this.coreService.getConfigKey(eConfigKey.DOCSIZE));
    this.maxSizesMedias.image = Number(this.coreService.getConfigKey(eConfigKey.IMGSIZE));
    this.maxSizesMedias.video = Number(this.coreService.getConfigKey(eConfigKey.VIDEOSIZE));

    this.accept = this.restrictedTo.byType.audio ? '.mp3' : '';
    this.accept += this.restrictedTo.byType.document ? this.accept ? ', .pdf, .doc, .docx' : '.pdf, .doc, .docx' : '';
    this.accept += this.restrictedTo.byType.image ? this.accept ? ', .jpg, .jpeg, .png' : '.jpg, .jpeg, .png' : '';
    this.accept += this.restrictedTo.byType.video ? this.accept ? ', .mp4' : '.mp4' : '';
    this.previewObjList = new Array<any>();
    this.media = new ParamsMedia();
    this.displayMedia = '';
    this.displayPreview = '';
    this.mediaPreviewsToDelete = [];
    this.ArrayTypes = [
      { key: '------', value: '' },
      { key: 'image', value: MediaTypeCode.IMAGE },
      { key: 'vidéo', value: MediaTypeCode.VIDEO },
      { key: 'audio', value: MediaTypeCode.AUDIO },
      { key: 'document', value: MediaTypeCode.DOCUMENT }
    ];
  }
  // #endregion CYCLE DE VIE

  // #region METHODES PUBLIQUES
  public cancelUpdate(): void {
    this.resetMedia.emit(undefined);
    this.media.Ident = 0;
    this.media.Path = '';
    this.media.Type = '';
    this.UnselectMedia('Main');
    this.UnselectMedia('Preview');
  }

  public UnselectMedia(type: string): void {

    switch (type) {
      case 'Main':
        this.displayMedia = '';
        this.fileObj = '';
        this.defaultName = '';
        this.media = this.media ? this.media : new ParamsMedia;
        this.media.NumberAutoPreviews = 0;
        this.media.Extension = '';
        this.media.Name = '';
        this.media.Type = '';
        this.media.size = null;
        break;
      case 'Preview':
        this.displayPreview = '';
        for (const personnalPreview of this.media.PersonnalsPreviews) {
          if (personnalPreview.includes('__P') && personnalPreview.includes('.png')) {
            const pathSplit: Array<string> = personnalPreview.indexOf('/') > -1 ? personnalPreview.split('/') : [personnalPreview];
            this.mediaPreviewsToDelete.push(pathSplit[pathSplit.length - 1]);
          }
        }
        this.media.PersonnalsPreviews = [];
        this.previewObjList = [];
        this.previewName = '';
        this.media.NumberPersonnalsPreviews = 0;
        this.media.PersonalsPreviewsSizes = [];
        break;
    }
  }

  public AfficheZoomMediaModal(idModal: string): void {
    this.modalService.open(idModal);
    //switch (idModal) {
    //  case 'zoomMediaNewModal':
    //    if (this.media.Path && this.media.Type === 'VIDEO') {
    //      this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
    //    }
    //    break;
    //}
  }


  public ImportMedias(): void {
    this.dialogService.showSplash(true);
    const mediasFromBo: Observable<MediaQueovalModel> = this.mediaService.GetMediasFromBo();
    const mediasFromStream: Observable<MediaQueovalModel> | Observable<MediaExtranetModel> = this.mediaService.getAllMediasClient();
    const MediasToCreate: Array<ParamsMedia> = new Array<ParamsMedia>();
    forkJoin([mediasFromBo, mediasFromStream]).subscribe((result: [MediaQueovalModel, MediaQueovalModel | MediaExtranetModel]) => {
      if (result[0].Alert && result[0].Alert.length > 0) {
        result[0].Alert.split('<br />').forEach((alert: string) => {
          this.toast.showWarningToast(alert);
        });
      }
      if (result[1].Alert && result[1].Alert.length > 0) {
        result[1].Alert.split('<br />').forEach((alert: string) => {
          this.toast.showWarningToast(alert);
        });
      }
      result[1].MediaModel.ListMedia.forEach((streamMedia: ParamsMedia) => {
        let AlreadyExistOnBo: boolean = false;

        for (let i: number = 0; i < result[0].MediaModel.ListMedia.length; i++) {
          if (streamMedia.FullName === result[0].MediaModel.ListMedia[i].FullName) {
            AlreadyExistOnBo = true;
            break;
          }
        }
        if (!AlreadyExistOnBo) {
          MediasToCreate.push(streamMedia);
        }
      });
      if (MediasToCreate.length > 0) {
        MediasToCreate.forEach((mediaToCreate: ParamsMedia) => {
          mediaToCreate.NumberAutoPreviews = this.numberPreviews('manuel', mediaToCreate);
        });
        this.mediaService.SaveListMediaBo(MediasToCreate).subscribe((resultMediasSavedBo: MediaQueovalModel) => {
          if (resultMediasSavedBo.Alert && resultMediasSavedBo.Alert.length > 0) {
            resultMediasSavedBo.Alert.split('<br />').forEach((alert: string) => {
              this.toast.showWarningToast(alert);
            });
          }
          if (resultMediasSavedBo.HasError) {
            this.toast.showAlertToast(resultMediasSavedBo.Error);
            this.dialogService.showSplash(false);
          } else {
            this.mediaService.RenameMediasOnStream(resultMediasSavedBo.MediaModel.ListMedia).subscribe((resultRenameMedias: MediaQueovalModel | MediaExtranetModel) => {
              if (resultRenameMedias.Alert && resultRenameMedias.Alert.length > 0) {
                resultRenameMedias.Alert.split('<br />').forEach((alert: string) => {
                  this.toast.showWarningToast(alert);
                });
              }
              if (resultRenameMedias.HasError) {
                this.toast.showAlertToast(resultRenameMedias.Error);
                this.dialogService.showSplash(false);
              } else {

                if (JSON.stringify(resultRenameMedias.MediaModel.ListMedia) !== JSON.stringify(resultMediasSavedBo.MediaModel.ListMedia)) {
                  this.mediaService.UpdateMultipleMediaBo(resultRenameMedias.MediaModel.ListMedia).subscribe(
                    (resultMultiUpdateBo: MediaQueovalModel) => {
                      if (resultMultiUpdateBo.Alert && resultMultiUpdateBo.Alert.length > 0) {
                        resultMultiUpdateBo.Alert.split('<br />').forEach((alert: string) => {
                          this.toast.showWarningToast(alert);
                        });
                      }
                      if (resultMultiUpdateBo.HasError) {
                        this.toast.showAlertToast(resultMultiUpdateBo.Error);
                      } else {
                        this.toast.showSuccessToast(this.coreService.getTrad('ImportCompleted'));
                      }
                      this.dialogService.showSplash(false);
                    });
                } else {
                  this.toast.showSuccessToast(this.coreService.getTrad('ImportCompleted'));
                  this.dialogService.showSplash(false);
                }
              }
            });
          }
        });
      } else {
        this.toast.showInfoToast(this.coreService.getTrad('NoMediaToImport'));
        this.dialogService.showSplash(false);
      }
    });
  }

  public onSelectChange(e: any): void {
    this.UnselectMedia('Main');
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.AfficheImageBeforeUpload(file, 'media');
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    const extensionAccepted: Array<string> = this.accept.toLowerCase().replace(/\.| /g, '').split(',');
    if (extensionAccepted.includes(extension)) {
      this.fileObj = file;
      if (this.fileObj) {
        this.defaultName = this.fileObj.name ? this.fileObj.name.toLocaleLowerCase() : '';

        this.media.Extension = this.fileObj.name ? this.fileObj.name.split('.')[this.fileObj.name.split('.').length - 1].toLocaleLowerCase() : '';
        const iExtension: number = this.defaultName.lastIndexOf(this.media.Extension);
        this.media.FullName = file.name;
        this.media.Name = this.defaultName.slice(0, iExtension - 1);
        switch (this.media.Extension) {
          case 'pdf':
          case 'doc':
          case 'docx':
            this.media.Type = MediaTypeCode.DOCUMENT;
            break;
          case 'mp4':
            this.media.Type = MediaTypeCode.VIDEO;
            break;
          case 'jpg':
          case 'jpeg':
          case 'png':
            this.media.Type = MediaTypeCode.IMAGE;
            break;
          case 'mp3':
            this.media.Type = MediaTypeCode.AUDIO;
            break;
        }
        this.media.NumberAutoPreviews = this.numberPreviews();
        this.media.size = file.size;
      }
    } else {
      this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} ${this.accept})`);
    }
  }

  public onPreviewChange(e: any): void {
    this.UnselectMedia('Preview');
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.AfficheImageBeforeUpload(file, 'preview');
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      this.previewObjList = [e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0]];
      if (this.previewObjList) {
        this.previewName = this.previewObjList[0].name ? this.previewObjList[0].name : '';
        this.media.NumberPersonnalsPreviews = 1;
        this.media.PersonalsPreviewsSizes = [file.size];
      }
    } else {
      this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} jpg, jpeg, png)`);
    }
  }

  public onDragOver(event: any): void {
    event.stopPropagation();
    event.preventDefault();
  }

  public uploadMedia(): void {
    if (this.media.Ident) {
      this.UpdateMedia();
    } else {
      this.CreateMedia();
    }
  }
  // #endregion METHODES PUBLIQUES

  // #region METHODES PRIVEES

  private numberPreviews(mode: string = 'auto', media: ParamsMedia = new ParamsMedia): number {
    switch (mode) {
      case 'auto':
        media = this.media;
        break;
    }
    let result: number = 0;
    switch (media.Extension.toLowerCase()) {
      case 'pdf':
      case 'doc':
      case 'docx':
        result = 1;
        break;
      case 'mp4':
        result = 4;
        break;
      case 'jpg':
      case 'jpeg':
      case 'png':
        result = 1;
        break;
      case 'mp3':
        result = 0;
        break;
    }
    return result;
  }

  private AfficheImageBeforeUpload(file: any, type: string): void {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => {
      switch (type) {
        case 'media':
          this.displayMedia = reader.result;
          //this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
          break;
        case 'preview':
          this.displayPreview = reader.result;
          break;
      }
    };
  }

  private createNewFile(newName: string, oldFile: File): File {
    // construction d'un nouveau File pour changer le nom de l'image par le nom saisi par l'utilisateur
    const blob: Blob = oldFile.slice(0, oldFile.size, oldFile.type);
    const file: File = new File([blob], newName, { type: oldFile.type });
    return file;
  }

  private checkPreviewsSizes(ArrayMediaObject: any): CheckPreviews {
    const result: CheckPreviews = new CheckPreviews();
    // vérification de la taille de toutes les previews
    result.isOk = true;
    // si previewObjList.length === 0 alors previewsSizesIsOk = true
    if (ArrayMediaObject.length > 0) {
      for (let i: number = 0; i < ArrayMediaObject.length; i++) {
        if (ArrayMediaObject[i].size > this.maxSizesMedias.image || ArrayMediaObject[i].size < 0) {
          result.isOk = false;
          const PrevIndexSize: PreviewsIndexSize = new PreviewsIndexSize();
          PrevIndexSize.index = i;
          PrevIndexSize.size = ArrayMediaObject[i].size;
          result.ArrayPreviews = new Array<PreviewsIndexSize>();
          result.ArrayPreviews.push(PrevIndexSize);
        }
      }
    }

    return result;
  }

  private UpdateMedia(): void {
    this.dialogService.showSplash(true);
    const previewsSizesIsOk: CheckPreviews = this.checkPreviewsSizes(this.previewObjList);

    if (previewsSizesIsOk.isOk) {
      // sauvegarde du média
      this.media.DateCreation = new Date();
      this.mediaService.UpdateMediaBo(this.media).subscribe(
        (resultUpdate: MediaQueovalModel) => {
          this.tag.saveTag(resultUpdate.MediaModel.Media.Ident.toString());
          if (resultUpdate.Alert && resultUpdate.Alert.length > 0) {
            resultUpdate.Alert.split('<br />').forEach((alert: string) => {
              this.toast.showWarningToast(alert);
            });
          }
          if (resultUpdate.HasError) {
            this.dialogService.showSplash(false);
            this.toast.showWarningToast(`${this.coreService.getTrad('FailureUpdateMedia')} ${resultUpdate.Error}`);
          } else {
            this.mediaService.deleteMedia(this.mediaPreviewsToDelete, MediaTypeCode.PREVIEW).subscribe(
              (resultDelete: MediaQueovalModel | MediaExtranetModel) => {
                if (resultDelete.Alert && resultDelete.Alert.length > 0) {
                  resultDelete.Alert.split('<br />').forEach((alert: string) => {
                    this.toast.showWarningToast(alert);
                  });
                }
                if (resultDelete.HasError) {
                  this.dialogService.showSplash(false);
                  this.toast.showWarningToast(`${this.coreService.getTrad('FailureDeleteOldPreviewsMedia')} ${resultDelete.Error}`);
                } else {
                  const subList: Array<any> = this.listPreviewsToSaveOnStream();
                  if (subList.length > 0) {
                    forkJoin(subList).subscribe(
                      (results: Array<any>) => {

                        results.forEach((result: any) => {
                          if (result.Alert && result.Alert.length > 0) {
                            result.Alert.split('<br />').forEach((alert: string) => {
                              this.toast.showWarningToast(alert);
                            });
                          }
                        });

                        let noError: boolean = true;
                        results.forEach((resultPreviews: any) => {
                          if (resultPreviews.HasError) {
                            noError = false;
                            this.toast.showAlertToast(this.coreService.getTrad('ErrorSavingMedia'));
                          }
                        });
                        if (noError) {
                          this.mediaPreviewsToDelete = [];
                          this.previewObjList = new Array<any>();

                          setTimeout(() => {
                            this.cancelUpdate();
                          }, 500);
                          this.newMedia.emit(this.media);

                          this.toast.showSuccessToast(this.coreService.getTrad('UpdateMediaSuccessfuly'));
                        }
                        this.dialogService.showSplash(false);
                      });
                    // this.savePreviewsOnStream();
                  } else {
                    this.dialogService.showSplash(false);
                    this.mediaPreviewsToDelete = [];
                    this.previewObjList = new Array<any>();

                    setTimeout(() => {
                      this.cancelUpdate();
                    }, 500);
                    this.newMedia.emit(this.media);
                    this.toast.showSuccessToast(this.coreService.getTrad('UpdateMediaSuccessfuly'));
                  }
                }
              });
          }
        });
    } else {
      let message: string = '';
      previewsSizesIsOk.ArrayPreviews.forEach((TooHeavyprev: PreviewsIndexSize) => {
        const mediaName: string = previewsSizesIsOk.ArrayPreviews.length > 1 ? `${this.previewObjList[TooHeavyprev.index]}: ` : '';
        message += `<br/> ${mediaName}${this.OptimizedDisplayOfMediaSize(TooHeavyprev.size)} > ${this.OptimizedDisplayOfMediaSize(this.maxSizesMedias.image)}`;
      });
      this.dialogService.showSplash(false);
      this.toast.showAlertToast(`${this.coreService.getTrad('TooHeavyPreviewFile')}: ${message}`);
    }
  }

  private checkMediaSizes(mediaSize: number): [boolean, number] {
    switch (this.media.Type) {
      case MediaTypeCode.IMAGE:
        return mediaSize <= this.maxSizesMedias.image && mediaSize > 0 ? [true, this.maxSizesMedias.image] : [false, this.maxSizesMedias.image];
      case MediaTypeCode.DOCUMENT:
        return mediaSize <= this.maxSizesMedias.document && mediaSize > 0 ? [true, this.maxSizesMedias.document] : [false, this.maxSizesMedias.document];
      case MediaTypeCode.AUDIO:
        return mediaSize <= this.maxSizesMedias.audio && mediaSize > 0 ? [true, this.maxSizesMedias.audio] : [false, this.maxSizesMedias.audio];
      case MediaTypeCode.VIDEO:
        return mediaSize <= this.maxSizesMedias.video && mediaSize > 0 ? [true, this.maxSizesMedias.video] : [false, this.maxSizesMedias.video];
      default:
        this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} ${this.accept})`);
        return [false, 0];
    }
  }

  private CreateMedia(): void {
    if (this.fileObj) {
      this.dialogService.showSplash(true);

      const uploadIsReady: [boolean, number] = this.checkMediaSizes(this.fileObj.size);

      if (uploadIsReady[0]) {
        // vérification de la taille de toutes les previews
        const previewsSizesIsOk: CheckPreviews = this.checkPreviewsSizes(this.previewObjList);

        if (previewsSizesIsOk.isOk) {
          // sauvegarde du média
          this.SaveOnBo();
        } else {
          let message: string = '';
          previewsSizesIsOk.ArrayPreviews.forEach((TooHeavyprev: PreviewsIndexSize) => {
            const mediaName: string = previewsSizesIsOk.ArrayPreviews.length > 1 ? `${this.previewObjList[TooHeavyprev.index]}: ` : '';
            message += `<br/> ${mediaName}${this.OptimizedDisplayOfMediaSize(TooHeavyprev.size)} > ${this.OptimizedDisplayOfMediaSize(this.maxSizesMedias.image)}`;
          });
          this.dialogService.showSplash(false);
          this.toast.showAlertToast(`${this.coreService.getTrad('TooHeavyPreviewFile')}: ${message}`);
        }
      } else {
        this.dialogService.showSplash(false);
        this.toast.showAlertToast(`${this.coreService.getTrad('TooHeavyFile')} : <br/>${this.OptimizedDisplayOfMediaSize(this.fileObj.size)} > ${this.OptimizedDisplayOfMediaSize(uploadIsReady[1])}`);
      }

    } else {
      this.dialogService.showSplash(false);
      this.toast.showAlertToast(this.coreService.getTrad('NoFile'));
    }
  }

  private OptimizedDisplayOfMediaSize(size: number): string {
    if ((size / 1048576) < 1) {
      if ((size / 1024) < 1) {
        return `${Math.round((size) * 100) / 100} octets`;
      } else {
        return `${Math.round((size / 1024) * 100) / 100} ko`;
      }
    } else {
      return `${Math.round((size / 1048576) * 100) / 100} Mo`;
    }
  }


  private SaveOnBo(): void {
    if (this.previewName) {
      this.media.PersonnalsPreviews.push(this.previewName);
    }
    this.media.DateCreation = new Date();
    this.mediaService.SaveMediaBo(this.media).subscribe(
      (result: MediaQueovalModel) => {
        this.tag.saveTag(result.MediaModel.Media.Ident.toString());
        let hasError: boolean = false;
        result.CodedAlerts.forEach((alert: Alert) => {
          switch (alert.Code) {
            case AlertCode.ALERT:
              this.toast.showWarningToast(alert.Message);
              break;
            case AlertCode.ERROR:
              this.toast.showAlertToast(alert.Message);
              hasError = true;
              break;
          }
        });

        if (result.HasBlockingAlert) {
          this.dialogService.showSplash(false);
        } else {
          this.media = result.MediaModel.Media;
          // définition d'un nouveau nom au format [idBoMedia].[extension]
          this.fileObj = this.createNewFile(this.media.FullName, this.fileObj);
          this.saveOnStream();
        }
      },
      (error: any) => {
        this.dialogService.showSplash(false);
        this.toast.showAlertToast(`${this.coreService.getTrad('ErrorSavingMedia')} : ${error}`);
      }
    );
  }

  private saveOnStream(): void {
    let subList: Array<any> = [this.mediaService.uploadMedia(this.fileObj, this.media.Type)];
    const subList2: Array<any> = this.listPreviewsToSaveOnStream();
    subList = subList.concat(subList2);
    if (subList.length > 0) {
      forkJoin(subList).subscribe((results: [any]) => {

        let noError: boolean = true;
        results.forEach((result: any) => {

          if (result.Alert && result.Alert.length > 0) {
            result.Alert.split('<br />').forEach((alert: string) => {
              this.toast.showWarningToast(alert);
            });
          }

          if (result.HasError) {
            noError = false;
            this.toast.showAlertToast(this.coreService.getTrad('ErrorSavingMedia'));
          }
        });
        if (noError) {
          this.media.Exist = true;
          this.media.Path = `${localStorage.getItem('configFile')}${localStorage.getItem('httpPath')}`;

          this.mediaService.CreatePreview(this.fileObj.name, this.media.NumberAutoPreviews, this.media).subscribe(
            (prevResult: MediaQueovalModel) => {

              if (prevResult.Alert && prevResult.Alert.length > 0) {
                prevResult.Alert.split('<br />').forEach((alert: string) => {
                  this.toast.showWarningToast(alert);
                });
              }

              if (prevResult.HasError) {
                this.toast.showAlertToast(this.coreService.getTrad('PreviewNotCreated'));
              } else {

                this.media = prevResult.MediaModel.Media;
                this.mediaService.UpdateMediaBo(this.media).subscribe(
                  (updateRes: MediaQueovalModel) => {
                    if (updateRes.Alert && updateRes.Alert.length > 0) {
                      updateRes.Alert.split('<br />').forEach((alert: string) => {
                        this.toast.showWarningToast(alert);
                      });
                    }

                    if (updateRes.HasError) {
                      this.toast.showWarningToast(`${this.coreService.getTrad('DataPartiallySaved')} ${updateRes.Error}`);
                    } else {

                      for (let i: number = 0; i < prevResult.MediaModel.Media.AutoPreviews.length; i++) {
                        updateRes.MediaModel.Media.AutoPreviews[i] = `${localStorage.getItem('configFile')}/${prevResult.MediaModel.Media.AutoPreviews[i]}`;
                      }
                      for (let i: number = 0; i < updateRes.MediaModel.Media.PersonnalsPreviews.length; i++) {
                        updateRes.MediaModel.Media.PersonnalsPreviews[i] = `${localStorage.getItem('configFile')}${updateRes.MediaModel.Media.PersonnalsPreviews[i]}`;
                      }
                      this.media = updateRes.MediaModel.Media;
                      setTimeout(() => {
                        this.cancelUpdate();
                      }, 500);
                      this.newMedia.emit(this.media);
                    }
                    this.dialogService.showSplash(false);
                  });

                this.toast.showSuccessToast(this.coreService.getTrad('FileSaved'));
              }
              this.dialogService.showSplash(false);
            });
        } else {
          this.dialogService.showSplash(false);
        }

      });
    } else {
      this.dialogService.showSplash(false);
      this.toast.showSuccessToast(this.coreService.getTrad('FileSaved'));
    }
  }

  private listPreviewsToSaveOnStream(): Array<any> {
    const list: Array<any> = [];
    this.previewObjList.forEach((previewObj: any) => {
      const name: string = this.media.Ident ? this.media.FullName : this.fileObj.name;
      list.push(this.mediaService.uploadPreview(previewObj, name));
    });
    return list;
  }

}

